import { Button, Input, Select } from "@appkit4/react-components";
import { useEffect, useState } from "react";
import toast from "../../../components/DismissibleToast";
import sqldatabaseService from "../../../services/sqldatabase/sqldatabase.service";
import "../home.scss";
import { getIdByName, getNamesFromList } from "../util/homeUtil";

const ReinstateResponseById = ({
  groupList,
  fetchGroups,
  resetForm,
  setResetForm,
}) => {
  const [selectedGroupName, setSelectedGroupName] = useState("");
  const [selectedGroupId, setSelectedGroupId] = useState("");
  const [responseId, setResponseId] = useState("");
  const [buttonDisabled, setButtonDisabled] = useState(false);

  useEffect(() => {
    if (resetForm) {
      setSelectedGroupName("");
      setSelectedGroupId("");
      setResponseId("");
      setResetForm(false);
    }
  }, [resetForm]);

  const isFormValid = selectedGroupId && responseId?.trim();

  const processReinstate = () => {
    if (!isFormValid) return;

    setButtonDisabled(true);
    const promise = sqldatabaseService
      .postReinstateResponse(selectedGroupId, responseId.trim())
      .then((response) => {
        if (response.status !== 200) {
          return {
            error: true,
            message: `Error: Status ${response.status} - ${response.err?.error || response.err}`,
          };
        }
        return response;
      });

    return toast
      .promise(promise, {
        loading: `Reinstating response ${responseId} in group: ${selectedGroupName}`,
        success: (response) => {
          if (response.error) {
            throw new Error(response.message);
          } else {
            fetchGroups();
          }
          setSelectedGroupName("");
          setSelectedGroupId("");
          setResponseId("");
          return `Response reinstated successfully in group: ${selectedGroupName}`;
        },
        error: (error) => {
          console.error("Reinstate response error:", error.message);
          return `Failed to reinstate response. ${error}`;
        },
      })
      .then(() => {
        setButtonDisabled(false);
      });
  };

  return (
    <div>
      <div className="flex-space-between" style={{ marginBottom: "1rem" }}>
        <Select
          placeholder={"Select Group"}
          value={selectedGroupName}
          style={{ width: "35rem" }}
          searchable
          data={getNamesFromList(groupList)}
          dropdownRenderMode={"portal"}
          onSelect={(groupName) => {
            setSelectedGroupName(groupName);
            setSelectedGroupId(getIdByName(groupName, groupList));
          }}
        ></Select>
      </div>
      <div className="flex-space-between" style={{ marginBottom: "1rem" }}>
        <Input
          title={"Response ID"}
          placeholder={"Enter Response ID"}
          value={responseId}
          style={{ width: "35rem" }}
          onChange={(value) => setResponseId(value)}
        ></Input>
      </div>
      <Button
        disabled={!isFormValid || buttonDisabled}
        onClick={() => processReinstate()}
      >
        Reinstate Response
      </Button>
    </div>
  );
};

export default ReinstateResponseById;
